module.exports = __webpack_public_path__ + "img/service-default.1f84f5d.jpg";